import { ENDPOINTS } from "@/constants/endpoints";
import { api } from "../network/api";
import type { CreateChangeRequestDto, GetChangeRequestsDto } from "@/models/dto/change-request.dto";
import type { PaginatedResponse } from "@/models/responses/base/baseResponse.response";
import type { ChangeRequest, RsaPinValidationResponse } from "@/models/responses/change-request/change-request.response";

const ChangeRequestService = {
  createChangeRequest: async function (
    dto: CreateChangeRequestDto
  ): Promise<ChangeRequest> {
    const response = await api.post(ENDPOINTS.CHANGE_REQUESTS.CREATE, dto);
    console.log(response)
    return response as unknown as ChangeRequest;
  },

  getChangeRequests: async function (
    dto: GetChangeRequestsDto
  ): Promise<PaginatedResponse<ChangeRequest>> {
    const response = await api.get(ENDPOINTS.CHANGE_REQUESTS.LIST, {
      params: dto,
    });
    return response as unknown as PaginatedResponse<ChangeRequest>;
  },

  getChangeRequestById: async function (id: string): Promise<ChangeRequest> {
    const response = await api.get(ENDPOINTS.CHANGE_REQUESTS.GET_BY_ID(id));
    return response as unknown as ChangeRequest;
  },

  validateRsaPin: async function (
    pin: string
  ): Promise<RsaPinValidationResponse> {
    const response = await api.get(ENDPOINTS.CHANGE_REQUESTS.VALIDATE_RSA_PIN, {
      params: { pin },
    });
    return response as unknown as RsaPinValidationResponse;
  },
};

export default ChangeRequestService;
